export default __webpack_public_path__ + "b4a201404a7562117edaf7caaa394b4b.svg";